interface BoundaryOverstepCheck {
  check(): boolean;
}

type Boundary = 'top' | 'bottom' | 'left' | 'right';

export class TopBoundaryOverstepCheck implements BoundaryOverstepCheck {
  constructor(
    private readonly _parent: DOMRect,
    private readonly _child: DOMRect,
    private readonly _offset: number = 0
  ) {}

  public check(): boolean {
    return this._child.top - this._offset < this._parent.top;
  }
}

export class BottomBoundaryOverstepCheck implements BoundaryOverstepCheck {
  constructor(
    private readonly _parent: DOMRect,
    private readonly _child: DOMRect,
    private readonly _offset: number = 0
  ) {}

  public check(): boolean {
    return this._child.bottom + this._offset > this._parent.bottom;
  }
}

export class LeftBoundaryOverstepCheck implements BoundaryOverstepCheck {
  constructor(
    private readonly _parent: DOMRect,
    private readonly _child: DOMRect,
    private readonly _offset: number = 0
  ) {}

  public check(): boolean {
    return this._child.left - this._offset < this._parent.left;
  }
}

export class RightBoundaryOverstepCheck implements BoundaryOverstepCheck {
  constructor(
    private readonly _parent: DOMRect,
    private readonly _child: DOMRect,
    private readonly _offset: number = 0
  ) {}

  public check(): boolean {
    return this._child.right + this._offset > this._parent.right;
  }
}

export class BoundaryOverstep {
  constructor(
    private readonly _parent: DOMRect,
    private readonly _child: DOMRect,
    private readonly _offset: number = 0
  ) {}

  public hasOverstepped(boundary: Boundary) {
    return this._overstepCheck(boundary).check();
  }

  public _overstepCheck(boundary: Boundary): BoundaryOverstepCheck {
    switch (boundary) {
      case 'top':
        return new TopBoundaryOverstepCheck(
          this._parent,
          this._child,
          this._offset
        );
      case 'bottom':
        return new BottomBoundaryOverstepCheck(
          this._parent,
          this._child,
          this._offset
        );
      case 'left':
        return new LeftBoundaryOverstepCheck(
          this._parent,
          this._child,
          this._offset
        );
      case 'right':
        return new RightBoundaryOverstepCheck(
          this._parent,
          this._child,
          this._offset
        );
    }
  }
}
